import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { DateRangePicker } from "../utils/DateRangePicker";
import { DaeAvulsoStore } from "../../stores/dae-avulso/DaeAvulsoStore";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { DeiStore } from "../../stores/dei/DeiStore";

@observer
export default class TarefasDaeAvulso extends React.Component<{}, {}> {

  obs = observable({
    tarefas_page: 1 as number,
    erros: [] as any,
    view_erros: false as boolean,
    date_start: "" as string,
    date_end: "" as string,
    arquivosSefip: [] as any[],
    uuid: "" as string,
    viewArquivos: false as boolean,
  })

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    DaeAvulsoStore.obs.selectEmpresaDae = newEmpresa()
    DaeAvulsoStore.obs.selectedPeriodDae = []
    DaeAvulsoStore.obs.tasks_dae_avulso = []
    DaeAvulsoStore.obs.tasks_dae_length = 0

    const hoje = new Date();

    this.obs.date_start = moment(hoje).format("YYYY-MM-DD");
    this.obs.date_end = moment(hoje).format("YYYY-MM-DD");

    DaeAvulsoStore.obs.selectedPeriodDae = [
      hoje,
      hoje
    ];

  }

  /**
   * Atualiza o número da página e consulta as solicitações com base na páginação.
   * 
   * @param {number} page Número da página.
   */
  handleBuscaTarefasPaged = async (page: number) => {
    this.obs.tarefas_page = page
    DaeAvulsoStore.handleDaePaged(page, DaeAvulsoStore.obs.selectEmpresaDae.cnpj, this.obs.date_start, this.obs.date_end, "dae_avulso");
  };

  /**
   * Busca as solicitações com base no filtro.
   */
  handleBuscaTarefas = async () => {
    await DaeAvulsoStore.handleDaePaged(1, DaeAvulsoStore.obs.selectEmpresaDae.cnpj, this.obs.date_start, this.obs.date_end, "dae_avulso");
    
    if (DaeAvulsoStore.obs.tasks_dae_avulso.length === 0) {
      toast.warn("Nenhuma tarefa encontrada para o período selecionado.");
    }
  };

  /**
   * Fecha modal dos erros.
   */
  onCloseErros() {
    this.obs.view_erros = false
    this.obs.erros = []
  }

  /**
   * Função responsável por manipular a alteração de datas da solicitação.
   * O valor é então formatado para o formato "YYYY-MM-DD" e atribuído às propriedades `date_start` e `date_end`.
   * @param {Date} val - A data representando um intervalo de datas. 
  */
  handleDateSolicitacaoChange = (val: Date) => {
    var string = val?.toString();
    var array = string.split(",");

    this.obs.date_start = moment(array[0]).format("YYYY-MM-DD")
    this.obs.date_end = moment(array[1]).format("YYYY-MM-DD")

    DaeAvulsoStore.obs.selectedPeriodDae = val;
  };

  /**
 * Função responsável por formatar o valor de status em uma tag visual.
 * Ela utiliza a função `getTag` para mapear o valor do status da linha (`row.status`) 
 * para uma representação visual, como uma tag ou marcador, que será exibida no componente.
 *
 * @param {any} cell - O valor da célula, que neste caso não é utilizado na lógica, mas é exigido pela assinatura do formato de célula.
 * @param {Object} row - A linha de dados contendo a propriedade `status`, usada para determinar o tipo de tag a ser exibida.
 * @returns {React.Element} Retorna um componente visual (uma tag) que representa o status da linha.
 */
  statusFormatter = (cell, row) => {

    return getTag(row.status, row.tipo);

  }

  /**
   * Formata a data e hora, adicionando 3 horas e exibindo no formato "DD/MM/YYYY ÁS HH:mm".
   * 
   * @param {any} cell - A célula contendo a data a ser formatada.
   * @param {Object} row - A linha de dados (não utilizada nesta função).
   * @returns {string} A data formatada com a hora.
   */
  dateFormatter = (cell, row) => {

    return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ÁS " + moment(cell).add(3, "hour").format("HH:mm");

  };

  /**
 * Formata os botões de ação para detalhes e arquivos.
 * O primeiro botão exibe detalhes ao ser clicado e o segundo só é habilitado
 * se o status da linha for "Concluído" ou 2.
 * 
 * @param {any} cell - O valor da célula (não utilizado nesta função).
 * @param {Object} row - A linha de dados contendo o status e outras informações.
 * @returns {JSX.Element} Dois botões renderizados para interações: um para visualizar detalhes e outro para visualizar arquivos.
 */
  buttonFormaterDetalhes = (cell, row) => {
    return (
      <>
        <MDBBtn
          color="default"
          rounded
          size="sm"
          onClick={(e) => this.handleViewDetalhes(row)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
        <MDBBtn
          disabled={!["Concluído", 2].includes(row.status)}
          color="default"
          rounded
          size="sm"
          onClick={(e) => this.handleViewArquivos(row)}
        >
          <img src="/images/detalhamento.png" width="18px" />
        </MDBBtn>
      </>
    );
  }

  /**
 * Função responsável por exibir os detalhes dos erros relacionados a uma linha de dados.
 * Ela verifica se o DAE é novo e busca os erros associados a ele. Caso contrário, realiza uma consulta para recuperar os erros.
 * Se não houver erros, exibe um aviso.
 * 
 * @param {Object} row - A linha de dados que contém as informações do DAE, incluindo possíveis erros.
 */
  handleViewDetalhes = async (row: any) => {

    DaeAvulsoStore.obs.loading_erros = true

    this.obs.erros = !row.error ? "" : row.error

    DaeAvulsoStore.obs.loading_erros = false

    if (this.obs.erros) {

      this.obs.view_erros = true

    } else {

      toast.warn("Nenhum erro encontrado!", {});
      return

    }

  };

  /**
 * Função responsável por exibir os arquivos associados a uma linha de dados.
 * Se o DAE for novo, faz o download do arquivo. Caso contrário, consulta os arquivos associados ao DAE.
 * Se arquivos forem encontrados, exibe os arquivos; caso contrário, exibe um aviso.
 * 
 * @param {Object} row - A linha de dados que contém as informações do DAE, incluindo `dae_new`, `task_id`, e `uuid`.
 */
  handleViewArquivos = async (row: any) => {

    if (row.tipo == "simples") {

      await DeiStore.downloadArquivo(DaeAvulsoStore.obs.selectEmpresaDae, row.task_id, this.format_receitas(row.receitas, row));

    } else {

      await DaeAvulsoStore.downloadArquivo(DaeAvulsoStore.obs.selectEmpresaDae, row.task_id);

    }

  };

  format_receitas = (cell, row) => {

    return cell.map(x => {

      return Object.entries(x).map(([campo, valor]) => {

        return campo

      })

    })

  }

  /**
 * Função responsável por filtrar empresas que não são do Simples Nacional.
 * 
 * @returns {Array} Um array contendo as empresas que possuem `simples_nacional` igual a `false`.
 */
  filter_empresa_simples = () => {

    // liberar dae quando empresa for simples com excesso

    return EmpresaStore.sortedEmpresas.filter(x => x.simples_nacional == false)

  }

  render() {

    let empresaText = DaeAvulsoStore.obs.selectEmpresaDae.cnpj != ""
      ? `${DaeAvulsoStore.obs.selectEmpresaDae.razao_social.substring(0, 38)}... (${formatCnpj(DaeAvulsoStore.obs.selectEmpresaDae.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>
        <MDBRow>
          <MDBCol md="3">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => {
                  DaeAvulsoStore.obs.selectEmpresaDae = e;
                  DaeAvulsoStore.obs.tasks_dae_avulso = [];
                  DaeAvulsoStore.obs.tasks_dae_length = 0;
                }}
                
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT} />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol md="3">
            <FormGroup label="Período" className="inputsPeriodoCalculos">
              <DateRangePicker
                onChange={this.handleDateSolicitacaoChange}
                value={DaeAvulsoStore.obs.selectedPeriodDae}
              />
            </FormGroup>
          </MDBCol>
          <MDBCol md="3" className="buttonConsultaCalculo">
            <Button
              text="Buscar"
              id="consultar"
              intent="primary"
              icon="tick"
              onClick={() => this.handleBuscaTarefas()}
              loading={DaeAvulsoStore.obs.loading_tasks}
            />
          </MDBCol>
        </MDBRow>
        <div>
          <BootstrapTable className="TableDefault" ref="table" data={DaeAvulsoStore.obs.tasks_dae_avulso}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.dateFormatter} dataField="inserted_at" width="20%">Data Criação</TableHeaderColumn>
            <TableHeaderColumn dataField="data_referencia" width="15%">Referência</TableHeaderColumn>
            <TableHeaderColumn dataField="data_vencimento" width="15%">Vencimento Original</TableHeaderColumn>
            <TableHeaderColumn dataField="data_calculo" width="15%">Pagar Até</TableHeaderColumn>
            <TableHeaderColumn dataField="documento_origem" width="15%">Documento de origem</TableHeaderColumn>
            <TableHeaderColumn dataField="informacao_adicional" width="30%">Informações</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.buttonFormaterDetalhes} width="15%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={DaeAvulsoStore.obs.tasks_dae_length}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefasPaged(page)} />
        </div>

        <Dialog
          isOpen={this.obs.view_erros}
          onClose={() => this.onCloseErros()}
          title="Erros ocorridos"
          className="dados-soli"
        >
          <div className={Classes.DIALOG_BODY}>
            <p>{this.obs.erros}</p>
          </div>

        </Dialog>

        <LoadingModal open={DaeAvulsoStore.obs.loading_erros} onClose={() => DaeAvulsoStore.obs.loading_erros = false} title={"Buscando erros"} />
        <LoadingModal open={DaeAvulsoStore.obs.loading_arquivos} onClose={() => DaeAvulsoStore.obs.loading_arquivos = false} title={"Baixando arquivo"} />
        <LoadingModal open={DaeAvulsoStore.obs.loadingDetalhes} onClose={() => DaeAvulsoStore.obs.loadingDetalhes = false} title={"Carregando"} />
        <LoadingModal open={DaeAvulsoStore.obs.loadingViewArquivo} onClose={() => DaeAvulsoStore.obs.loadingViewArquivo = false} title={"Abrindo arquivo"} />

      </>
    )
  }
}